import { render, staticRenderFns } from "./PrintBadges.vue?vue&type=template&id=ef5269d8&scoped=true&"
import script from "./PrintBadges.vue?vue&type=script&lang=js&"
export * from "./PrintBadges.vue?vue&type=script&lang=js&"
import style0 from "./PrintBadges.vue?vue&type=style&index=0&id=ef5269d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5269d8",
  null
  
)

component.options.__file = "PrintBadges.vue"
export default component.exports